import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Api} from '../../../smoothr-web-app-core/api/api';
import Order from '../../../smoothr-web-app-core/models/Order';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject, Subscription} from 'rxjs';
import {OrderUtils} from '../../../smoothr-web-app-core/utils/order-utils';
import {SignInPage} from '../../pages/sign-in/sign-in.page';
import {SignUpPage} from '../../pages/sign-up/sign-up.page';
import {Router} from '@angular/router';
import {axiosErrorToMessage, numberToCurrency} from '../../../smoothr-web-app-core/utils/utils';
import {AnalyticsService} from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import {FormControl} from '@angular/forms';
import PromoCode from 'src/smoothr-web-app-core/models/PromoCode';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ModalController} from '@ionic/angular';
import {AlertInfoModalComponent} from '../alert-info-modal/alert-info-modal.component';

@Component({
	selector: 'app-vital-code',
	templateUrl: './vital-code.component.html',
	styleUrls: ['vital-code.component.scss']
})
export class VitalCodeComponent {
	public vitalCodeInput = new FormControl();
	public loading$ = new BehaviorSubject<boolean>(false);
	inputCode: PromoCode = null;

	@Input() set vitalCodeValue(value: string) {
		this.vitalCodeInput.patchValue(value);
	}
	// @Input() order: Order;
	@Output() vitalCode = new EventEmitter<string>();
	@Output() successOrder = new EventEmitter<Order>();
	constructor(
		private snackBar: MatSnackBar,
		private analytics: AnalyticsService,
		private modalCtrl: ModalController,
		private translate: TranslateService,
		private repository: RepositoryService
	) {}

	ngOnInit() {}
	// loadCode() {
	// 	this.inputCode = this.vitalCodeInput?.value;
	// 	this.vitalCode.emit(this.vitalCodeInput?.value);
	// }
	deleteCode() {
		this.inputCode = null;
	}
	async loadCode() {
		if (!this.vitalCodeInput?.value || this.vitalCodeInput?.value.replace(' ', '').length === 0) {
			await AlertInfoModalComponent.show(
				this.modalCtrl,
				this.translate.instant('promo_code.not_valid'),
				null,
				null,
				this.translate.instant('change_time_alert.cancel')
			);
			return;
		}
		this.loading$.next(true);
		try {
			this.inputCode = this.vitalCodeInput?.value;
			this.loading$.next(false);
			this.vitalCode.emit(this.vitalCodeInput?.value);
		} catch (e) {
			console.log(e);
			this.loading$.next(false);
			if (e.response.status === 404) {
				await AlertInfoModalComponent.show(
					this.modalCtrl,
					null,
					this.translate.instant('promo_code.not_valid'),

					null,
					this.translate.instant('change_time_alert.cancel')
				);
				return;
			}
			return;
		}
	}
}
